import React from 'react';

import { SwipeableDrawerProps } from '@material-ui/core';

import { Drawer } from './styles';

const DrawerSwipeable = ({ children, ...rest }: SwipeableDrawerProps) => <Drawer {...rest}>{children}</Drawer>;
export default DrawerSwipeable;
